import React from 'react';
import PropTypes from 'prop-types';

const Header = ({
    name,
    tele,
    email,
    web,
    address,
    logoUrl,
    serialNumber
}) => (
    <div style={{
        display: 'flex',
        alignItems: 'center',
        borderBottom: '2px solid #333',
        padding: '2px 0',
        marginBottom: '1px',
        justifyContent: 'space-between'
    }}>
        {/* <div style={{ marginRight: 8 }}>
            <img
                src={logoUrl}
                alt="Logo or Photo"
                style={{
                    width: 40,
                    height: 40,
                    objectFit: 'cover',
                    borderRadius: 6,
                    border: '1px solid #ccc',
                    background: '#f9f9f9'
                }}
            />
        </div> */}
        <div>
            <div style={{ fontSize: 16, fontWeight: 'bold', marginBottom: 4 }}>{name}</div>
            <div style={{ fontSize: 13, marginBottom: 2 }}>{address}</div>
            <div style={{ fontSize: 12, color: '#555', display: 'flex', gap: 12 }}>
                <span><strong>Tel:</strong> {tele}</span>
                <span><strong>Email:</strong> {email}</span>
                <span><strong>Web:</strong> {web}</span>
            </div>
        </div>
        <div style={{ minWidth: 100, textAlign: 'right', marginLeft: 'auto' }}>
            <label htmlFor="serialNumber" style={{ marginRight: 8, fontSize: 13 }}> File No:</label>
            <input
                id="serialNumber"
                type="text"
                value={serialNumber}
                readOnly
                style={{ width: 80, textAlign: 'right' }}
            />
        </div>
    </div>
);

Header.propTypes = {
    name: PropTypes.string.isRequired,
    tele: PropTypes.string.isRequired,
    email: PropTypes.string.isRequired,
    web: PropTypes.string.isRequired,
    address: PropTypes.string.isRequired,
    logoUrl: PropTypes.string.isRequired,
    serialNumber: PropTypes.string.isRequired
};

export default Header;